<template>
  <div class="" v-if="!loading">
    <div class="payment-completed min-height-100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="text-center">
              <h4 class="text-success">
                Congratulations! Your booking is confirmed.
              </h4>
              <p>
                You have successfully booked Tickets for . You will be receiving
                a confirmation email shortly.
              </p>
            </div>
            <div class="final_ticket event-final-ticket bg-light my-lg-5">
              <div class="row mx-0">
                <div class="col-md-9 py-3">
                  <div class="row">
                    <div class="col-3">
                      <img :src="base_url + this.e_img" class="img-fluid" />
                    </div>
                    <div class="col-9">
                      <div>
                        <h5 class="font-weight-bold text-pink mb-1">
                          {{ this.e_name }}
                        </h5>
                        <div class="small-md">
                          <span v-html="this.e_s_description"></span>
                        </div>
                        <div class="small-md my-2">
                          <div class="text-muted">DATE & TIME:</div>
                          <div>
                            <span
                              >{{
                                moment(this.es_time, "h:mm a").format("h:mm a")
                              }},
                            </span>
                            <span
                              >{{ moment(this.es_date).format("MMM DD") }},
                              {{ moment(this.es_date).format("YYYY") }}</span
                            >
                          </div>
                        </div>
                        <div class="small-md">{{ this.ev_address }}</div>

                        <hr class="my-2" />
                        <div>
                          <div class="small text-muted mb-2">
                            SEATS
                            <span class="font-weight-bold"
                              >({{ this.seatTotal }})</span
                            >
                          </div>
                          <div
                            class="d-flex justify-content-between small-md"
                            v-for="(data, index) in this.getSelectedSeats"
                            :key="index"
                          >
                            <span
                              >{{ data.st_name }} X {{ data.no_of_seat }}
                              <span v-if="data.sl_name != ''"
                                ><br />{{ data.sl_name }}</span
                              >
                            </span>
                            <span
                              >{{ data.currency }}
                              {{ data.price * data.no_of_seat }}</span
                            >
                          </div>
                        </div>
                        <hr class="my-2" />
                      </div>

                      <div class="d-flex justify-content-between text-pink">
                        <div class="font-weight-bold">Amount Paid</div>
                        <div class="font-weight-bold">
                          {{ this.currency }} {{ this.paymentTotal }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="
                    col-md-3
                    d-flex
                    flex-column
                    justify-content-center
                    py-3
                  "
                  style="border-left: 1px dashed grey"
                >
                  <div class="qrDetails">
                    <!-- <img src="@/assets/img/qr2.png" class="w-50 mb-2" alt /> -->
                    <qrcode-vue :value="value" :size="size" level="H" />
                    <div class="small text-muted">BOOKING ID</div>
                    <div class="font-weight-bold">{{ this.value }}</div>
                  </div>
                  <hr class="my-2" />
                  <div class="qrDetails">
                    <div class="small text-muted">MODE OF PAYMENT</div>
                    <div
                      class="font-weight-bold"
                      v-if="this.payment_options == 1"
                    >
                      Credit Card
                    </div>
                    <div
                      class="font-weight-bold"
                      v-if="this.payment_options == 2"
                    >
                      Debit Card
                    </div>
                  </div>
                  <!-- <div class="qrDetails">
                    <div class="small text-muted">BOOKING DATE AND TIME</div>
                    <div class="font-weight-bold">24th Aug 2022</div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <router-link to="/events" class="btn btn-pink px-5"
            >VIEW MORE EVENTS</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Slick from "vue-slick";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { EVENT_URL } from "@/helper/constant.js";
import moment from "moment";
import QrcodeVue from "qrcode.vue";
//
export default {
  data() {
    return {
      value: "",
      loading: true,
      size: 100,
      email: "",
      mobile: "",
      active: 0,
      e_name: "",
      e_img: "",
      ev_address: "",
      genre: [],
      es_date: "",
      es_time: "",
      getSelectedSeatName: "",
      getSelectedSeats: [],
      moment,
      paymentTotal: 0,
      seatTotal: 0,
      payment_options: "",
      e_s_description: "",
      url: EVENT_URL,
      base_url: "",
      currency: "",
    };
  },
  components: {
    QrcodeVue,
  },
  mounted() {
    const { paymentID } = this.$route.params;
    this.value = paymentID;
    this.getBookDetails(paymentID);
  },
  methods: {
    getBookDetails(id) {
      let that = this;
      this.showLoading();
      makeRequest(
        "/v1/event/bookeddetails/" + id,
        "GET",
        null,
        null,
        EVENT_URL,
        false
      )
        .then((response) => {
          that.loading = false;
          this.hideLoading();
          const { error, res } = response;
          if (!error) {
            this.es_date = res.data.data.schedule.es_date;
            this.es_time = res.data.data.schedule.es_time;
            this.e_name = res.data.data.event_detail.e_name;
            this.e_img = res.data.data.event_detail.e_image;
            // this.getSelectedSeats = res.data.data.seat_info;
            this.ev_address = res.data.data.venue.ev_address;
            this.currency = res.data.data.book_info.currency;
            this.payment_options = res.data.data.book_info.purchase_mode;
            this.e_s_description = res.data.data.event_detail.e_s_description;

            let temp5 = res.data.data.seat_info;
            let temp4 = {};
            let temp6 = [];
            // this.currencyCode = res.data.data.seat_info[0].currency;
            temp5.map((d) => {
              this.paymentTotal += parseFloat(d.total_price);
              if (temp4[d.seat_type_id]) {
                let no_of_seat = parseInt(temp4[d.seat_type_id].no_of_seat) + 1;
                let total_price = parseFloat(d.price) * parseFloat(no_of_seat);
                let sl_name = temp4[d.seat_type_id].sl_name + "," + d.sl_name;

                temp4[d.seat_type_id] = {
                  st_name: d.st_name,
                  sl_name: sl_name,
                  no_of_seat: no_of_seat,
                  qty: no_of_seat,
                  price: d.price,
                  currency: d.currency,
                  total_price: total_price,
                };
              } else {
                temp4[d.seat_type_id] = {
                  st_name: d.st_name,
                  sl_name: d.sl_name,
                  no_of_seat: d.no_of_seat,
                  qty: d.no_of_seat,
                  price: d.price,
                  currency: d.currency,
                  total_price: d.total_price,
                };
              }
            });
            console.log("temp4 :>> ", temp4);
            let allkeys = Object.keys(temp4);
            allkeys.map((d) => {
              this.seatTotal += parseInt(temp4[d].no_of_seat);
              temp6.push(temp4[d]);
            });

            this.getSelectedSeats = temp6;
            this.base_url = res.data.base_url;
          } else {
            console.log("Response Error ");
          }
        })
        .catch((error) => {
          this.hideLoading();
          console.log("Error", error);
        });
    },
  },
};
</script>
<style >
.small-md {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/completed-page.vue